
var React = require('react');

module.exports = function() {
  return React.createElement(
	"svg",
	{ viewBox: "0 0 64 64" },
	React.createElement(
		"g",
		{ fill: "#fff" },
		React.createElement("path", { d: "m16.1 12.5h26v14.1h-26z" }),
		React.createElement("path", { d: "m46.1 24.1c0 0 4.1-2 9.8-1.3-5.6-2.6-9.8-.6-9.8-.6v1.9", opacity: ".8" }),
		React.createElement("path", { d: "m46.1 45.5c0 0 3.8.1 7.7-2.7-2.6 4.8-7.7 4.7-7.7 4.7v-2", opacity: ".8" })
	),
	React.createElement("path", { d: "m59.7 22.6c-.8-5-11.4-3.1-13.6-2.7v-11h-34.1v49c0 5.4 34.1 5.4 34.1 0v-8.6c6.4-.2 11.4-5.8 12.8-11.2 1-3.8 1.5-11.5.8-15.5m-16 31.5c0 4.4-29.3 4.4-29.3 0v-42.1h29.3v42.1m10.8-16c-.8 3.3-4.1 6.2-8.3 6.3v-19.7c1.7-.4 9-2 9.5 1.2.4 3.5-.4 8.8-1.2 12.2", fill: "#a1b8c7", opacity: ".8" }),
	React.createElement("path", { d: "m42.1 26.6h-26v26.2c0 3.9 26 3.9 26 0v-26.2", fill: "#fdb73e" }),
	React.createElement(
		"g",
		{ fill: "#d8d2b8" },
		React.createElement("path", { d: "m43.7 8.7c0 2.5-3.1 4.6-7 4.6-3.9 0-7-2.1-7-4.6 0-2.6 3.1-4.6 7-4.6 3.9 0 7 2.1 7 4.6" }),
		React.createElement("path", { d: "m48.8 10.7c0 2.1-2.1 3.9-4.6 3.9-2.5 0-4.6-1.7-4.6-3.9 0-2.1 2.1-3.9 4.6-3.9 2.5.1 4.6 1.8 4.6 3.9" }),
		React.createElement("path", { d: "m15.4 23.4c0 2.1-1.9 3.8-4.3 3.8-2.4 0-4.3-1.7-4.3-3.8 0-2.1 1.9-3.8 4.3-3.8 2.3 0 4.3 1.7 4.3 3.8" }),
		React.createElement("path", { d: "m17.5 28.5c0 2.1-1.9 3.8-4.3 3.8-2.4 0-4.3-1.7-4.3-3.8 0-2.1 1.9-3.8 4.3-3.8 2.4 0 4.3 1.7 4.3 3.8" }),
		React.createElement("path", { d: "m25.9 11.1c0 4.1-3.8 7.5-8.5 7.5-4.7 0-8.5-3.4-8.5-7.5 0-4.1 3.8-7.5 8.5-7.5 4.8 0 8.5 3.4 8.5 7.5" }),
		React.createElement("path", { d: "m18.1 16.6c0 3.6-3.2 6.5-7.1 6.5-3.9 0-7.1-2.9-7.1-6.5 0-3.6 3.2-6.5 7.1-6.5 4 0 7.1 2.9 7.1 6.5" }),
		React.createElement("path", { d: "m34.6 7.5c0 3-2.9 5.5-6.4 5.5-3.5 0-6.4-2.5-6.4-5.5 0-3 2.9-5.5 6.4-5.5 3.6 0 6.4 2.5 6.4 5.5" })
	),
	React.createElement(
		"g",
		{ fill: "#fff" },
		React.createElement("path", { d: "m43.4 9.5c0 2.5-3 4.5-6.6 4.5-3.6 0-6.6-2-6.6-4.5 0-2.5 3-4.5 6.6-4.5 3.6-.1 6.6 1.9 6.6 4.5" }),
		React.createElement("path", { d: "m47.9 10.9c0 1.9-2 3.4-4.5 3.4-2.5 0-4.5-1.5-4.5-3.4 0-1.9 2-3.4 4.5-3.4 2.4 0 4.5 1.5 4.5 3.4" }),
		React.createElement("path", { d: "m16.5 23.2c0 2-1.9 3.6-4.2 3.6-2.3 0-4.2-1.6-4.2-3.6 0-2 1.9-3.6 4.2-3.6 2.4 0 4.2 1.6 4.2 3.6" }),
		React.createElement("path", { d: "m36.5 12.5c0 2-1.9 3.6-4.2 3.6-2.3 0-4.2-1.6-4.2-3.6 0-2 1.9-3.6 4.2-3.6 2.4 0 4.2 1.6 4.2 3.6" }),
		React.createElement("path", { d: "m26.6 11.8c0 3.9-3.7 7.1-8.2 7.1-4.6 0-8.2-3.2-8.2-7.1 0-3.9 3.7-7.1 8.2-7.1 4.5 0 8.2 3.2 8.2 7.1" }),
		React.createElement("path", { d: "m19 16.9c0 3.3-3.1 5.9-6.9 5.9-3.8 0-6.9-2.7-6.9-5.9 0-3.3 3.1-5.9 6.9-5.9 3.8-.1 6.9 2.6 6.9 5.9" }),
		React.createElement("path", { d: "m28.7 22.1c0 3.3-3.1 5.9-6.9 5.9s-6.9-2.7-6.9-5.9c0-3.3 3.1-5.9 6.9-5.9 3.8-.1 6.9 2.6 6.9 5.9" }),
		React.createElement("path", { d: "m34.6 8.4c0 2.9-2.7 5.2-6 5.2-3.3 0-6-2.3-6-5.2 0-2.9 2.7-5.2 6-5.2 3.3 0 6 2.3 6 5.2" }),
		React.createElement("path", { d: "m18.3 28.5c0 2-1.9 3.6-4.2 3.6-2.3 0-4.2-1.6-4.2-3.6 0-2 1.9-3.6 4.2-3.6 2.3 0 4.2 1.6 4.2 3.6" }),
		React.createElement("path", { d: "m22.3 26.6c0 1.9-1.8 3.5-4 3.5-2.2 0-4-1.6-4-3.5 0-1.9 1.8-3.5 4-3.5 2.2 0 4 1.6 4 3.5" })
	),
	React.createElement(
		"g",
		{ fill: "#d8d2b8" },
		React.createElement("path", { d: "m25.9 21.7c-.3-.4-.8-.8-1.3-1-.2-.1-.5-.2-.8-.2-.2 0-.5 0-.8 0h-.4l-.1-.4c-.2-.5-.5-.9-.9-1.2-.2-.2-.4-.3-.6-.4-.2-.1-.3-.1-.4-.2-.1 0-.3-.1-.4-.1-1.1-.2-2.3 0-3.1.7l-.5.4-.4-.3c-.1-.1-.2-.2-.3-.2-.2-.1-.2-.1-.4-.2-.2-.1-.5-.2-.8-.2-.6 0-1.2.2-1.7.6.2-.6.9-1.1 1.6-1.2.4-.1.8-.1 1.2 0 .2 0 .5.1.6.2.2.1.4.2.6.3h-.8c.9-1.1 2.8-1.7 4.4-1.3.2 0 .4.1.6.2.2.1.4.2.5.2.4.2.7.4 1 .7.5.5.9 1.2.9 1.9l-.5-.4c.4 0 .7.1 1 .2.2.1.3.1.4.2.1.1.3.2.4.3.6.3 1 .9 1 1.4" }),
		React.createElement("path", { d: "m29.5 6.1c-.6-.1-1.2-.1-1.7.1-.1 0-.2.1-.4.1-.2.1-.3.1-.3.2-.2.1-.4.3-.6.4l-.2.2-.5-.1c-.5-.2-1.1-.3-1.7-.3-.3 0-.6.1-.8.1-.4.1-.5.2-.8.3-.9.5-1.5 1.4-1.5 2.4v.6h-.6c-.1 0-.3 0-.4 0-.2 0-.2 0-.4.1-.3.1-.5.2-.7.4-.4.3-.7.9-.7 1.5-.3-.5-.3-1.3.1-1.8.2-.3.5-.6.8-.7.1-.1.4-.2.5-.2.5-.3.7-.4.9-.4l-.5.6c-.3-1.4.5-2.9 1.9-3.6.3-.2.8-.3 1.1-.4.4-.1.8-.1 1.2-.1.8 0 1.6.3 2.2.7l-.7.1c.3-.2.6-.3.9-.5.2-.1.3-.1.5-.1.1 0 .4-.1.5-.1.7 0 1.4.2 1.9.5" })
	),
	React.createElement(
		"g",
		{ fill: "#fee0af" },
		React.createElement("ellipse", { cx: "33.8", cy: "34.4", rx: "5.5", ry: "5.2" }),
		React.createElement("ellipse", { cx: "25.9", cy: "42.9", rx: "4.1", ry: "3.9" }),
		React.createElement("ellipse", { cx: "34", cy: "46.5", rx: "2.7", ry: "2.6" }),
		React.createElement("ellipse", { cx: "27.9", cy: "51.9", rx: "1.9", ry: "1.8" })
	)
);
};



//////////////////
// WEBPACK FOOTER
// ./~/react-svg-emojione/dist/beer.js
// module id = 681
// module chunks = 0